import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Middle_Ages_-_Medieval_Europe.png';

function HistoryPageMedieval() {
  return (
    <TopicPage
      topicKey="Medieval Europe"
      title="History: Medieval Europe"
      backgroundImage={bg}
      startRoute="/History-Medieval-Europe-Go"
      scrollLabels={[
        "Feudalism and Society",
        "The Church and Power",
        "The Black Death",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageMedieval;   